import { gate } from 'hub-http/gates';
import { userInfoSync } from 'hub-http/userInfo';
import { SUPPORTED_ASSET_TYPES } from 'personalization-lib/constants/assetTypes';
import { READ_SCOPES, WRITE_SCOPES } from 'personalization-lib/constants/auth';
const safeGetUserInfo = () => {
  try {
    return userInfoSync();
  } catch (error) {
    return undefined;
  }
};
const getUserGates = () => {
  var _safeGetUserInfo;
  return (_safeGetUserInfo = safeGetUserInfo()) === null || _safeGetUserInfo === void 0 ? void 0 : _safeGetUserInfo.gates;
};
export const hasGate = _gate => {
  var _getUserGates$include, _getUserGates;
  return (_getUserGates$include = (_getUserGates = getUserGates()) === null || _getUserGates === void 0 ? void 0 : _getUserGates.includes(_gate)) !== null && _getUserGates$include !== void 0 ? _getUserGates$include : false;
};
export const getCanSeeAcademyLinks = () => hasGate(gate('Personalize:AcademyVideos'));
const getUserScopes = () => {
  var _safeGetUserInfo2;
  return (_safeGetUserInfo2 = safeGetUserInfo()) === null || _safeGetUserInfo2 === void 0 || (_safeGetUserInfo2 = _safeGetUserInfo2.user) === null || _safeGetUserInfo2 === void 0 ? void 0 : _safeGetUserInfo2.scopes;
};
export const hasScope = scope => {
  var _getUserScopes$includ, _getUserScopes;
  return (_getUserScopes$includ = (_getUserScopes = getUserScopes()) === null || _getUserScopes === void 0 ? void 0 : _getUserScopes.includes(scope)) !== null && _getUserScopes$includ !== void 0 ? _getUserScopes$includ : false;
};
export const hasScopes = scopes => scopes.every(scope => hasScope(scope));
export const getCanViewPersonalization = () => hasScope('personalize-view');
export const getCanCreateVariants = () => hasScope('personalize-edit');

/**
 * Returns true if the user has write access to the asset type.
 *
 * @param assetType - The asset type to check.
 * @returns Returns true/false if the user has write access to the asset type.
 */
export const canEditAssetType = assetType => Boolean(WRITE_SCOPES[assetType] && hasScopes(WRITE_SCOPES[assetType]));

/**
 * Returns true if the user has read access to the asset type.
 *
 * @param assetType - The asset type to check.
 * @returns Returns true/false if the user has read access to the asset type.
 */
export const canReadAssetType = assetType => Boolean(READ_SCOPES[assetType] && hasScope(READ_SCOPES[assetType]));

/**
 * Returns the asset types that the user has write access to.
 *
 * @param assetTypes - The asset types to filter. Defaults to all supported asset types.
 * @returns The asset types that the user has write access to.
 */
export const getWritableAssetTypes = (assetTypes = [...SUPPORTED_ASSET_TYPES]) => assetTypes.filter(canEditAssetType);

/**
 * Returns the asset types that the user has read access to.
 *
 * @param assetTypes - The asset types to filter. Defaults to all supported asset types.
 * @returns The asset types that the user has read access to.
 */
export const getReadableAssetTypes = (assetTypes = [...SUPPORTED_ASSET_TYPES]) => assetTypes.filter(canReadAssetType);